<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row class="no-gutters align-center">
      <v-col cols="12" sm="6" :md="$canRoute('registered-user?tab=1') !== 1 ? 5 : 2" :lg="$canRoute('registered-user?tab=1') !== 1 ? 5 : 2">
        <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
          single-line solo hide-details>
        </v-text-field>
      </v-col>

      <v-col cols="12" sm="6" md="3" lg="3">
        <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="selectedDatesText" placeholder="Date filter" prepend-icon="mdi-calendar"
              append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo
              class="custom-select"></v-text-field>
          </template>
          <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="cancelSelection">
              Cancel
            </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="confirmSelection">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>

      <v-col cols="12" sm="12" md="4" lg="4">
        <ul>
          <li>
            <span class="">Total IB:</span>
            <span>{{ formattedAllNumber(ibApproved) }}</span>
          </li>

          <li>
            <span class="">Doc. Verified:</span>
            <span>{{ formattedAllNumber(docApproved) }}</span>
          </li>
          <li>
            <span class="text--green">Total User:</span>
            <span>{{ formattedAllNumber(pagination?.total) }}</span>
          </li>
        </ul>
      </v-col>

      <v-col class="mx-auto" cols="12" sm="6" md="2" lg="2">
        <v-btn tile elevation="0" v-if="$canRoute('registered-user?tab=1') === 1" to="/create-new-user-account"
          class="mt-8 text-capitalize btn-account mb-0 mx-0" color="greenMain">
          + New User
        </v-btn>
      </v-col>

      <v-col class="mx-auto" cols="12" sm="6" md="1" lg="1">
        <v-btn v-if="$canRoute('registered-user?tab=1') === 1" @click.prevent="downloadCSVall" :loading="csvLoading" :disabled="csvLoading" tile elevation="0" to="" class="mt-8 text-capitalize btn-account mb-0 mx-0" color="greenMain">
          <v-icon small>mdi mdi-tray-arrow-down</v-icon>CSV
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable registerUserTable"
            :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="users" :server-items-length="pagination?.total || 10"
              :options.sync="tableOptions" :loading="isLoading" :items-per-page="tableOptions?.itemsPerPage"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.fullname="{ item }" v-if="$canRoute('registered-user?tab=1') === 1">
                <router-link class="text-capitalize text--ash" :to="`/registered-user-details/${item?.id}`">
                  {{ `${item.fullname} (${item?.id})` }}
                </router-link>
              </template>
              <template v-slot:item.fullname="{ item }" v-else>
                <span class="text-capitalize text--ash">
                  {{ `${item.fullname} (${item?.id})` }}
                </span>
              </template>
              <template v-slot:item.user_ib_status="{ item }">
                <div class="status-selection status-selection-blocked-user">
                  <v-switch :input-value="Boolean(handleStatus(item.user_ib_status))" @change="handleSelectChange(item)"
                    inset color="#039de9" :ripple="false">
                  </v-switch>
                </div>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ formatMySQLDate(item?.created_at) }}
              </template>
              <template v-slot:item.email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">{{
                        copiedStates[item.id]
                          ? "mdi mdi-check"
                          : "mdi-content-copy"
                      }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item.email }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.immediate_ib="{ item }">
                <router-link v-if="item?.referred_by" class="text-capitalize text--ash"
                  :to="`/partner-list-details?id=${item?.referred_by}`">
                  {{ `${item?.referredBy?.fname} (${item?.referred_by})` }}
                </router-link>
                <span v-else>N/A</span>
              </template>
              <template v-slot:item.admin_name="{ item }">
                {{ item?.admin_name || "Self" }}
              </template>
              <template v-slot:item.manager="{ item }">
                <v-dialog transition="scale-transition" origin="center center" max-width="985px"
                  v-model="searchManagerModal[item?.id]" content-class="upload-modal">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex align-items-center">
                      <div @click="handleCloseManagerModal(item)" v-bind="attrs" v-on="on"
                        :class="verifyModal(item.managerModal)">
                        <v-btn x-small icon tile style="background: #039de91a">
                          <v-icon x-small color="#039de9">mdi-plus</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </template>

                  <template>
                    <v-card-title class="upload-title">
                      <span>Assign Manager for {{ item.fullname }}</span>
                      <v-btn icon dark @click="handleCloseManagerModal(item)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <AssignManagerTable :assignUser="item"></AssignManagerTable>
                  </template>
                </v-dialog>
              </template>
              <template v-slot:item.details="{ item }" v-if="$canRoute('registered-user?tab=1') > 0" >
                <router-link class="links text-decoration-none" :to="'/registered-user-details/' + item.id">
                  <v-icon color="#039de9" small> mdi-eye-outline </v-icon>
                </router-link>
              </template>
               <template v-slot:item.details="{ item }" v-else>
                ...
              </template>
              <template v-slot:item.user_doc_status="{ item }">
                <div :style="{
                  display: 'flex',
                  gap: '2px',
                  alignItems: 'center',
                  justifyContent: item.user_doc_status.startsWith('V')
                    ? 'normal'
                    : 'space-between',
                }">
                  <!-- <v-icon small>
                    {{ verifyDocIcon(item.user_doc_status) }}
                  </v-icon> -->
                  {{ item.user_doc_status }}
                  <div v-if="item.user_doc_status !== 'Verified'" v-bind="attrs" v-on="on">
                    <v-btn :to="{ path: '/profile-verify', query: { id: item.id } }" x-small icon tile
                      style="background: #039de91a">
                      <v-icon x-small color="#039de9">mdi-plus</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>
            </v-data-table>
            <!-- <div
              class="action-btn"
              style="
                display: flex;
                align-items: flex-end;
                justify-content: flex-end;
              "
            >
              <v-btn
                small
                outlined
                elevation="0"
                @click="downloadExcel"
                class="ma-0 text-capitalize ash--text"
                >Excel
                <v-icon small right> mdi-arrow-collapse-down </v-icon>
              </v-btn>
            </div> -->
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { formatMySQLDate } from "@/_helpers/formateDate";
import { formatNumber } from "@/_helpers/formatNumber";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import toast from "@/services/Notification";
import { IBREQUEST__ACTIONS, REGISTEREDUSER__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import * as XLSX from "xlsx";
import AssignManagerTable from "./AssignManagerTable.vue";
import ProfileVerifyModal from "./ProfileVerifyModal.vue";

export default {
  data() {
    return {
      attrs: "",
      on: "",
      search: "",
      searchTimeout: null,
      date: null,
      selectedDates: [],
      csvLoading: false,
      selectedDatesText: null,
      isCopied: false,
      copiedStates: {},
      uploadModal: false,
      searchManagerModal: {},
      ibStatusSlots: ["Client", "Approved", "Requested", "Cancelled"],
      modal: false,
      dialog: false,
      selectedSlot: "",
      headers: [
        { text: "Registered At", align: "start", value: "created_at" },
        { text: "Name", value: "fullname" },
        { text: "Email", value: "email" },
        { text: "Referred By", value: "immediate_ib" },
        { text: "Registered By", value: "admin_name" },
      ],
    };
  },

  components: {
    ProfileVerifyModal,
    AssignManagerTable,
  },

  computed: {
    ...mapState("registeredUser", [
      "users",
      "ibApproved",
      "totalUser",
      "docApproved",
      "isLoading",
      "pagination",
      "allregistereduserusercsv"
    ]),

    ...mapState("admins", ["loggedAdmin"]),

    tableOptions: {
      get() {
        return this.$store.state.registeredUser.tableOptions;
      },
      set(value) {
        this.$store.commit("registeredUser/TABLEOPTIONS", value);
      }
    },
  },

  methods: {
    formatMySQLDate,
    ...mapActions("registeredUser", [
      REGISTEREDUSER__ACTIONS.REGISTEREDUSER,
      REGISTEREDUSER__ACTIONS.DASHBOARDREGISTEREDUSERS,
      REGISTEREDUSER__ACTIONS.UPDATEIBSTATUS,
      REGISTEREDUSER__ACTIONS.ALLREGISTEREDUSERUSER,
    ]),

    ...mapActions("ibrequest", [
      IBREQUEST__ACTIONS.UPDATEIBREQ
    ]),

    handleCloseManagerModal(item) {
      this.$set(this.searchManagerModal, item?.id, false);
    },

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    async handleSelectChange(item) {
      // Convert boolean to binary (0/1)
      let newStatus = item.ib_status == 1 ? 0 : 1;

      this[IBREQUEST__ACTIONS.UPDATEIBREQ]({
        client_id: item.id,
        new_status: newStatus
      });

      // Update the item's status
      item.ib_status = newStatus;

      await this.fetchData();
      this[REGISTEREDUSER__ACTIONS.DASHBOARDREGISTEREDUSERS]();
    },

    async downloadCSVall() {
      this.csvLoading = true;

      try {
        const params = {
          page: 1,
          limit: -1,
          search: "",
        };
        await this[REGISTEREDUSER__ACTIONS.ALLREGISTEREDUSERUSER](params);
        this.downloadCSV();
      } catch (error) {
        console.log(error);
      } finally {
        this.csvLoading = false;
        console.log(this.allregistereduserusercsv);
      }
    },

    async downloadCSVall() {
      this.csvLoading = true;
      try {
        const params = {
          page: 1,
          limit: -1,
          search: "",
        };
        await this[REGISTEREDUSER__ACTIONS.ALLREGISTEREDUSERUSER](params);
        this.downloadCSV(); // after data is fetched
      } catch (error) {
        console.error("Download CSV Error:", error);
      } finally {
        this.csvLoading = false;
      }
    },

    downloadCSV() {
      const headers = [
        'Affilade Code',
        'Registered At',
        'Name',
        'Email',
        'Mobile',
        'Referred By',
        'Country',
        'Client Status',
        'Registred By',
      ];

      const csvData = this.allregistereduserusercsv.map(user => [
        user.id || '',
        user.created_at || 'N/A',
        `${user.fname || ''} ${user.lname || ''}`,
        user.email || 'N/A',
        user.mobile || 'N/A',
        user.referredBy?.fname ? `${user.referredBy.fname} ${user.referredBy.lname}` : 'N/A',
        user.countries?.name || 'N/A',
        user.ib_status == 1 ? 'Partner' : 'Client',
        user.admin?.fname ? `${user.admin.fname} ${user.admin.lname}` : 'Self',
      ]);

      const csvContent = [
        headers,
        ...csvData
      ].map(row => row.join(',')).join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', `partner-list-${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    handleStatus(status) {
      if (status === 1) return true;
      else return false;
    },

    getTextColor(item) {
      const firstLetter = item.charAt(0).toLowerCase();

      const colorMap = {
        a: "#ff0000",
        b: "#00ff00",
      };

      if (colorMap[firstLetter]) {
        return colorMap[firstLetter];
      } else {
        const colors = [
          "#ff0000",
          "#00ff00",
          "#0000ff",
          "#ffff00",
          "#00ffff",
          "#ff00ff",
          "#000000",
          "#ffffff",
        ];
        const randomIndex = Math.floor(Math.random() * colors.length);
        return colors[randomIndex];
      }
    },

    verifyDocIcon(status) {
      if (status.toLowerCase() === "verified")
        return "mdi mdi-check-circle-outline green--text mr-1";
      else if (status.toLowerCase() === "not verified")
        return "mdi mdi-close-circle-outline red--text mr-1";
      else if (status.toLowerCase() === "pending")
        return "mdi mdi-refresh yellow--text mr-1";
      else if (
        status.toLowerCase() === "pending" ||
        status.toLowerCase() === "not verified"
      )
        return "mdi mdi-clock-alert yellow--text mr-1";
      else return "mdi mdi-refresh yellow--text mr-1";
    },

    verifyModal(statusModal) {
      if (statusModal === "Verified") return "d-none ml-0";
      else if (statusModal === "Decline") return "d-block ml-2";
      else return "d-block ml-2";
    },

    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },

    copyText(item) {
      navigator.clipboard.writeText(item.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },

    downloadExcel() {
      const wb = XLSX.utils.book_new();
      const apiData = this.users;

      const modifiedData = apiData.map((item) => ({
        "USER ID": item.id,
        NAME: item.fullname,
        EMAIL: item.email,
        "REGISTERED AT": item.created_at,
        DOCUMENT: item.user_doc_status,
        "IB STATUS": item.user_ib_status,
      }));

      const ws = XLSX.utils.json_to_sheet(modifiedData);
      XLSX.utils.book_append_sheet(wb, ws, "Registered Users");
      const totalRow = modifiedData.length + 2;

      ws["!ref"] = XLSX.utils.encode_range({
        s: { c: 0, r: 0 },
        e: { c: 9, r: totalRow },
      });

      XLSX.writeFile(wb, "registered_users.xlsx");
    },

    async fetchData() {
      const parameter = {
        page: Number(this.tableOptions.page) || 1,
        limit: Number(this.tableOptions.itemsPerPage) || 10,
        search: this.search
      };

      if (this.selectedDates?.length === 2) {
        parameter.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
      }

      await this[REGISTEREDUSER__ACTIONS.REGISTEREDUSER](parameter);
    },

    async handleSearch(value) {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },

    getCurrentDate() {
      return new Date().toISOString().split("T")[0];
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.options.page = 1;
      this.fetchData();
    },
  },

  async created() {
    await this.fetchData();
    if (this.$canRoute('registered-user?tab=1') === 1) {
      this.headers.push({ text: "Manager", value: "manager" });
      this.headers.push({ text: "Document", value: "user_doc_status" });
      this.headers.push({ text: "Ib Status", value: "user_ib_status" });
    }
    this.headers.push({ text: "Details", value: "details" });
  },
};
</script>

<style scoped>
.mx-auto {
  margin-left: 0 auto;
  text-align: center;
}
</style>
